export default "__VITE_ASSET__BQ47RvhH__"